import styled from '@emotion/styled';
import { ReactNode } from 'react';

type P = {
  header: ReactNode;
  content: ReactNode;
  contentRef?: React.Ref<HTMLDivElement>;
};

const ListContainer = ({ header, content, contentRef }: P) => {
  return (
    <Container>
      <HeaderContainer>{header}</HeaderContainer>
      <ContentContainer ref={contentRef}>{content}</ContentContainer>
    </Container>
  );
};
export default ListContainer;

const Container = styled.div`
  position: absolute;
  background-color: var(--dk-bg, white);
  border-radius: 4px;
  border: 1px solid black;
  width: 100%;
  z-index: 3;
  margin-top: 12px;
  box-shadow: 0 16px 32px 0 rgba(0, 0, 0, 0.08);
`;

const HeaderContainer = styled.div`
  padding: 16px;
  border-bottom: 1px solid black;
`;

const ContentContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
